import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import { DEV_AUTH_CONFIG } from "../aws-config";

const UserLogin = () => {
  useEffect(() => {
    Amplify.configure(DEV_AUTH_CONFIG);
    handleLogin();
  }, []);

  const handleLogin = async () => {
    try {
      const oauthUrl = `https://${DEV_AUTH_CONFIG.Auth.oauth.domain}/login?redirect_uri=${DEV_AUTH_CONFIG.Auth.oauth.redirectSignIn}&response_type=code&client_id=${DEV_AUTH_CONFIG.Auth.userPoolWebClientId}&scope=openid+email`;
      window.location.href = oauthUrl;
    } catch (error) {
      console.error("Error during sign-in", error);
    }
  };

  return <div></div>;
};

export default UserLogin;
